"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mangrove = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var SelectSpace_1 = require("../../inputs/SelectSpace");
var SpaceType_1 = require("../../SpaceType");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Size_1 = require("../render/Size");
var Mangrove = (function (_super) {
    __extends(Mangrove, _super);
    function Mangrove() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MANGROVE,
            tags: [Tags_1.Tags.PLANT],
            cost: 12,
            tr: { oxygen: 1 },
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(4); }),
            metadata: {
                cardNumber: '059',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.greenery(Size_1.Size.MEDIUM).asterix(); }),
                description: 'Requires +4 C or warmer. Place a greenery tile ON AN AREA RESERVED FOR OCEAN and raise oxygen 1 step. Disregard normal placement restrictions for this.',
                victoryPoints: 1,
            },
        }) || this;
    }
    Mangrove.prototype.play = function (player) {
        return new SelectSpace_1.SelectSpace('Select ocean space for greenery tile', player.game.board.getAvailableSpacesForOcean(player), function (foundSpace) {
            return player.game.addGreenery(player, foundSpace.id, SpaceType_1.SpaceType.OCEAN);
        });
    };
    Mangrove.prototype.getVictoryPoints = function () {
        return 1;
    };
    return Mangrove;
}(Card_1.Card));
exports.Mangrove = Mangrove;
